/*
 * Copyright (c) 2019-2021 LogMeIn
 * All Rights Reserved Worldwide.
 *
 * THIS PROGRAM IS CONFIDENTIAL AND PROPRIETARY TO LOGMEIN
 * AND CONSTITUTES A VALUABLE TRADE SECRET.
 */

import React, { useContext } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { Flex } from '@getgo/chameleon-chakra-ui';
import { Spacing } from '../../../../themes/GoToTheme';
import { GoToJoinHeading } from '../../../JoinPages/GoToPages/Components/Heading/GoToJoinHeading';
import { GoToCaption } from '../../../JoinPages/GoToPages/Components/Texts/GoToCaption';
import { buildNativeDownloadUrl } from '../../../../services/UrlService';
import { SessionContext } from '../../../../context/SessionContext';
import { StyledButton } from '../../../JoinPages/GoToPages/Components/Buttons/StyledButton';
import {
  useSendTelemetry,
  TelemetryComponent,
  TelemetryAction,
  TelemetryState,
} from '../../../../hooks/useSendTelemetry';
const messages = defineMessages({
  heading: {
    id: 'goto.install.heading',
  },
  buttonCaption: {
    id: 'goto.join.button.native.caption',
  },
  buttonLabel: {
    id: 'goto.install.nativeDownloadButton',
  },
});

interface Props {
  onDownloadButtonClick: () => void;
}

export const GoToInstallPage: React.FC<Props> = ({ onDownloadButtonClick }) => {
  const { formatMessage: f } = useIntl();
  const { openerLaunchToken } = useContext(SessionContext);
  const sendTelemetry = useSendTelemetry();
  return (
    <>
      <GoToJoinHeading greeting heading={f(messages.heading)} />
      <Flex
        marginBottom={Spacing.CoreLayout4}
        minWidth='min-content'
        alignItems='center'
      >
        <StyledButton
          link={buildNativeDownloadUrl(openerLaunchToken)}
          onClick={() => {
            onDownloadButtonClick();
            sendTelemetry(
              TelemetryComponent.Native,
              TelemetryAction.Download,
              TelemetryState.First
            );
          }}
          marginRight={Spacing.CoreLayout2}
        >
          {f(messages.buttonLabel)}
        </StyledButton>
        <GoToCaption>{f(messages.buttonCaption)}</GoToCaption>
      </Flex>
    </>
  );
};
